import { render, staticRenderFns } from "./AsignacionDocumentosIndex.vue?vue&type=template&id=3578bc0e"
import script from "./AsignacionDocumentosIndex.vue?vue&type=script&lang=js"
export * from "./AsignacionDocumentosIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports